import React from 'react'

export default function UpdatedSoon() {
    return (
        <>
            <section className="coming-page">
                <div className="coming-box">
                    <h1>Coming Soon</h1>

                    <p>
                        This section is currently being updated.
                        Please check back soon.
                    </p>
                </div>
            </section>
        </>
    )
}
